import { Pipe, PipeTransform } from '@angular/core';
import { LangService } from '../services/lang.service';

@Pipe({
  name: 'lang'
})
export class LangPipe implements PipeTransform {

  constructor(private lang: LangService) {}

  transform(nr: number, idLang: number): string {
    return this.lang.get(nr, idLang)
  }

}
